import { render, staticRenderFns } from "./JoinedMultiple.vue?vue&type=template&id=8cb2f284"
import script from "./JoinedMultiple.vue?vue&type=script&lang=js"
export * from "./JoinedMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports